import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import FinanceRecordList from './FinanceRecordList';
import { IStore, listStores } from '../../service/api/store';
import FinanceRecordTypeList from './FinanceRecordTypeList';
const { TabPane } = Tabs;
const { Option } = Select;

const FinanceRecordView = (props: any) => {
  const [currentTabKey, setCurrentTabKey] = useState<number>(1);
  const [stores, setStores] = useState<IStore[]>();
  const [financeRecordVisible, setFinanceRecordVisible] = useState(false);
  const [financeRecordTypeVisible, setFinanceRecordTypeVisible] = useState(false);
  const [financeRecordIncome, setFinanceRecordIncome] = useState(false);
  const [filterStoreIds, setFilterStoreIds] = useState(undefined);
  const [searchKeyword, setSearchKeyword] = useState<string>();
  const exactRef = useRef(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  const tabExtraContent = () => {
    switch (currentTabKey) {
      case 1:
        return <div>
          <Select placeholder="全部校区"
            style={{ minWidth: 180, marginRight: '10px' }} mode="multiple"
            onChange={(value: any) => {
              setFilterStoreIds(value);
            }}>
            {storeOptions}
          </Select>
          <Input type='text' placeholder="请输入描述/金额" style={{ width: 200, marginRight: '10px' }}
              onChange={(e)=>{
                console.log("xxx:"+e.target.value)
                setSearchKeyword(e.target.value)}}
              allowClear>
          </Input>
          {/* <Button type="ghost" style={{ width: 100, marginLeft: '10px' }} icon={<SearchOutlined />} onClick={() => {
            loadData(); }}>搜索
          </Button> */}
          <Button type="primary" onClick={() => {
            setFinanceRecordVisible(true);
            setFinanceRecordIncome(false)
          }} icon={<PlusOutlined />}>
            新增支出
        </Button>
          <Button type="primary" onClick={() => {
            setFinanceRecordVisible(true);
            setFinanceRecordIncome(true)
          }} icon={<PlusOutlined />}>
            新增收入
        </Button>
        </div>
      case 2:
        return <Button type="primary" style={{ marginRight: '20px' }} onClick={() => {
          setFinanceRecordTypeVisible(true);
        }} icon={<PlusOutlined />}>
          新增类型
        </Button>
      default:
        return <></>
    }
  }

  function onTabChange(key: any) {
    console.log(key);
    setCurrentTabKey(Number(key));
    loadData();
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  // // 搜索
  // const onSearchKeyword = (e: { target: { value: React.SetStateAction<string | undefined>; }; }) => {
  //   // console.log(e.target.value);
  //   setSearchKeyword(e.target.value);
  // };

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['财务管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Tabs defaultActiveKey="1" onChange={onTabChange} style={{ marginBottom: 32 }}
              tabBarExtraContent={tabExtraContent()}>
              <TabPane tab="财务记录" key="1">
                <FinanceRecordList
                  visible={financeRecordVisible}
                  setVisible={setFinanceRecordVisible}
                  income={financeRecordIncome}
                  filterStoreIds={filterStoreIds}
                  searchKeyword={searchKeyword}
                />
              </TabPane>
              <TabPane tab="财务类型" key="2">
                <FinanceRecordTypeList
                  visible={financeRecordTypeVisible}
                  setVisible={setFinanceRecordTypeVisible}
                />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FinanceRecordView;
